import { h, FunctionComponent, ComponentChildren } from "preact"; /** @jsx h */
import { clsx } from 'clsx';
import { useState, useEffect } from 'preact/hooks';

import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';
import { Cta } from "../components/Cta";
import { ROUTES } from "@pyqml/shared";



export type ISubscribeSectionProps = {
    children?: ComponentChildren; // e.g. Intro <span className="sr-only">(current)</span>
    // allow to use this component as a wrapper for other components
    as?: string
};

export const SubscribeSection = (props: ISubscribeSectionProps) => {

    return (
        <Layout.Section weight="equal">
            
            <div weight="top">
                <Subheader title="Learn Quantum Machine Learning" />
                <p>
                    Whether you just get started with quantum computing and machine learning or you're
                    already a senior machine learning engineer, <b>Hands-On Quantum Machine Learning With Python</b> is
                    your comprehensive guide to get started with <b>Quantum Machine Learning</b> - the use of
                    quantum computing for the computation of machine learning algorithms.
                </p>
            </div>

            {/* 
            <Layout.Column>
                <Subheader title="Available Resources" />
                <List.Ordered>
                    <List.Item
                        title="Books"
                        abstract=""
                        
                    />
                    <List.Item
                        title="Email Bulletin"
                        abstract=""
                        
                    />
                    <List.Item
                        title="Online Blog, Tutorial, and Glossary"
                        abstract=""
                        
                    />
                    
                    
                </List.Ordered>
            </Layout.Column>
            <Layout.Column>
                <Subheader title="The PyQML Promise" />
                <List.Ordered>
                    <List.Item
                        title="You Don't Need to be a Physicist"
                        abstract=""
                        
                        linkTo="./article.html"
                        
                    />
                    <List.Item
                        title="You Don't Need to be a Mathematician"
                        abstract=""
                        
                        linkTo="./article.html"
                        
                    />
                    <List.Item
                        title="You Don't Need to be a Computer Scientist"
                        abstract=""
                        
                        linkTo="./article.html"
                        
                    />
                </List.Ordered>
            </Layout.Column>
            <Layout.Column>
                <Subheader title="Catering To You" />
                <List.Ordered>
                    <List.Item
                        title="Student"
                        abstract=""
                        image={"HomeImg"}
                        linkTo="./article.html"
                        authorLinkTo="./author.html"
                        authorName="Frank Zickert"
                        publishedAt="Dec 12"
                        readingTime="5"
                    />
                    <List.Item
                        title="Practitioner"
                        abstract=""
                        image={"HomeImg"}
                        linkTo="./article.html"
                        authorLinkTo="./author.html"
                        authorName="Frank Zickert"
                        publishedAt="Dec 12"
                        readingTime="5"
                    />
                    <List.Item
                        title="Researcher"
                        abstract=""
                        image={"HomeImg"}
                        linkTo="./article.html"
                        authorLinkTo="./author.html"
                        authorName="Frank Zickert"
                        publishedAt="Dec 12"
                        readingTime="5"
                    />
                </List.Ordered>
            </Layout.Column>
            */}
            <div className="row" weight="bottom">
                
                <Cta
                    size="full"
                    text={ "" }
                    ctaText={ "Start your QML journey now" }
                    ctaLink={ROUTES.BLOG_SUBSCRIBE}
                />
            </div>
            
        </Layout.Section>
    );
}
  
export default SubscribeSection;
